import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as t } from "react/jsx-runtime";
import s from "react";
import { InlineImage as r } from "./InlineImage.js";
const l = "components-module_text-1-5__3OPus",
  m = {
    text15: l
  },
  a = n => n,
  f = function () {
    let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a;
    return {
      marks: {
        placeholderResolver: n,
        placeholder: _ref => {
          let {
            children: e
          } = _ref;
          return /* @__PURE__ */t(s.Fragment, {
            children: e
          });
        },
        sup: _ref2 => {
          let {
            children: e
          } = _ref2;
          return /* @__PURE__ */t("sup", {
            children: e
          });
        },
        sub: _ref3 => {
          let {
            children: e
          } = _ref3;
          return /* @__PURE__ */t("sub", {
            children: e
          });
        },
        link: _ref4 => {
          let {
            value: e,
            children: o
          } = _ref4;
          return (
            // eslint-disable-next-line react/jsx-no-target-blank
            /* @__PURE__ */
            t("a", {
              href: e.href,
              target: e.openInNewTab ? "_blank" : void 0,
              rel: e.openInNewTab ? "noopener noreferrer" : void 0,
              children: o
            })
          );
        }
      },
      types: {
        inlineImage: _ref5 => {
          let {
            value: e
          } = _ref5;
          return e ? /* @__PURE__ */t(r, _objectSpread({}, e)) : null;
        },
        imageWithAlign: _ref6 => {
          let {
            value: e
          } = _ref6;
          return e ? /* @__PURE__ */t(r, _objectSpread({}, e)) : null;
        }
      },
      block: {
        disclaimer: _ref7 => {
          let {
            children: e
          } = _ref7;
          return /* @__PURE__ */t("small", {
            children: e
          });
        },
        "text-1-5x": _ref8 => {
          let {
            children: e
          } = _ref8;
          return /* @__PURE__ */t("span", {
            className: m.text15,
            children: e
          });
        }
      }
    };
  };
export { f as defaultComponents };